// @flow strict
import * as React from 'react';
import { Moniker, type PixelConfiguration } from './MonikerConfiguration';

/* A callback to fire a pixel. */

const usePixelCallback = (config: PixelConfiguration) => {
  const loadMoniker = React.useContext(Moniker);
  const callback = React.useCallback(
    () =>
      new Promise<SyntheticEvent<HTMLIFrameElement> | null>(resolve => {
        if (loadMoniker) {
          loadMoniker(config, resolve);
        } else {
          resolve(null);
        }
      }),
    [loadMoniker, config],
  );
  if (DEBUG && !loadMoniker) {
    throw new Error('MonikerConfiguration not properly set!');
  }
  return callback;
};

export default usePixelCallback;
